import React from 'react';

import withCard from './WithCard';
import Display from '../../../Types/Components/Display';

const DisplayCard = (props) => {
  return <Display {...props} />
}

export default withCard(DisplayCard);